/*
 * Brand carousel — accessible, in-repo replacement for the Swiper carousel that
 * used to be initialised by the compiled index.bundle.js (which we cannot edit).
 * Extends Dawn's native scroll-snap SliderComponent (assets/global.js) and adds:
 *   - scrolling a focused-but-off-screen slide into view (WCAG 2.4.7)
 *   - a polite slide-change announcement (WCAG 4.1.3)
 * The section markup renames the wrapper class so the bundle no longer targets
 * this carousel; SliderComponent handles keyboard scrolling and the disabled-at-
 * ends prev/next buttons.
 */
if (typeof SliderComponent !== 'undefined' && !customElements.get('brand-carousel')) {
  class BrandCarousel extends SliderComponent {
    constructor() {
      super();
      // SliderComponent bails (no this.slider/nextButton) on malformed markup.
      if (!this.slider) return;

      this.statusElement = this.querySelector('[id^="SlideStatus-"]');
      this.announceTemplate = this.dataset.slideAnnouncement || '[index] / [total]';

      // Keep a focused slide visible — without this, tabbing to an off-screen
      // link leaves the focus ring outside the viewport.
      this.slider.addEventListener('focusin', (event) => {
        const slide = event.target.closest('[id^="Slide-"]');
        if (!slide) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        slide.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      });

      this.addEventListener('slideChanged', this.announceSlide.bind(this));

      // SliderComponent disables the prev/next button at the ends; if that button
      // holds focus the browser drops focus to <body>. Move focus to the opposite
      // (still-enabled) button. slideChanged fires before the disable, so defer.
      this.addEventListener('slideChanged', () => {
        queueMicrotask(() => {
          const active = document.activeElement;
          if (active && active.hasAttribute('disabled') && (active === this.prevButton || active === this.nextButton)) {
            (active === this.nextButton ? this.prevButton : this.nextButton).focus();
          }
        });
      });
    }

    announceSlide(event) {
      if (!this.statusElement || this.totalPages == null) return;
      const slide = event.detail.currentElement;
      const label = slide ? slide.getAttribute('data-slide-label') || '' : '';

      let message = this.announceTemplate
        .replace('[index]', event.detail.currentPage)
        .replace('[total]', this.totalPages);
      if (label) message += `, ${label}`;

      // Debounce so a continuous scroll across several slides announces only the
      // slide it settles on, and re-clear so an identical message re-announces.
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => {
        this.statusElement.textContent = '';
        this.statusElement.textContent = message;
      }, 400);
    }
  }

  customElements.define('brand-carousel', BrandCarousel);
}
